var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42.25 22.5H58V27H42.25V22.5Z",
    fill: "#E6E6E6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M42.25 33.75H58V38.25H42.25V33.75Z",
    fill: "#E6E6E6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M42.25 45H58V49.5H42.25V45Z",
    fill: "#E6E6E6"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13 22.5H28.75V27H13V22.5Z",
    fill: "#E6E6E6"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13 33.75H28.75V38.25H13V33.75Z",
    fill: "#E6E6E6"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M13 45H28.75V49.5H13V45Z",
    fill: "#E6E6E6"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M62.5 11.25H8.5C7.30689 11.2512 6.16299 11.7257 5.31934 12.5693C4.47568 13.413 4.00119 14.5569 4 15.75V56.25C4.00119 57.4431 4.47568 58.587 5.31934 59.4307C6.16299 60.2743 7.30689 60.7488 8.5 60.75H62.5C63.6931 60.7488 64.837 60.2743 65.6807 59.4307C66.5243 58.587 66.9988 57.4431 67 56.25V15.75C66.9988 14.5569 66.5243 13.413 65.6807 12.5693C64.837 11.7257 63.6931 11.2512 62.5 11.25ZM8.5 15.75H33.25V56.25H8.5V15.75ZM37.75 56.25V15.75H62.5V56.25H37.75Z",
    fill: "#E6E6E6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon2);
export default __webpack_public_path__ + "static/media/icon2.48e4620a78f23de6701eb4f1a4202a3d.svg";
export { ForwardRef as ReactComponent };